<template lang="pug">
  .component.component-backoffice-note(v-if="item")
    .card( v-if="$is('listing')")
      .inner-content
        cardN(:showBullets="false", :showAction="false", :columns="6")
          .field-value(slot="n1") TOC{{item.toc.id}}
          .field-value(slot="n1") {{item.toc.name}}
          .field-value(slot="n2") Status
          .field-value(slot="n2") {{item.status}}
          .field-value(slot="n2") {{item.signed_on}}
          .field-value(slot="n3") Document date
          .field-value(slot="n3") {{item.document_date}}
          .field-value(slot="n4") Type
          .field-value(slot="n4") {{item.toc.toc_type.name}}
          .field-value(slot="n4") {{item.toc.toc_type.group}}
          .field-value(slot="n5") Version
          .field-value(slot="n5") {{item.document_version}}
          .field-value(slot="n6", v-if="hasAttachment") Document
          .field-value(slot="n6", v-if="hasAttachment")
            a(href="#", v-if="")
              i.fa.fa-2x.fa-file-pdf-o(@click="fileUrl()")

</template>
<script type="text/babel">
  import CardN from 'components/structure/CardN'
  import Dropdown from '../structure/foundation/Dropdown'
  import VehicleCostButtons from '../structure/ui/actions/VehicleCostButtons'
  import VehicleNoteButtons from '../structure/ui/actions/VehicleNoteButtons'
  import {mapState} from 'vuex'
  import TocButtons from '../structure/ui/actions/TocButtons'

  export default {
    name: 'Toc',
    components: {
      TocButtons,
      VehicleNoteButtons,
      VehicleCostButtons,
      Dropdown,
      CardN,
    },
    data() {
      return {}
    },
    created() {
    },
    methods: {
      fileUrl() {
        window.open(`${window.env.API_URL}/storage/${this.item.toc.attachment}`)
      },
    },
    computed: {
      hasAttachment() {
        return this.item.toc.attachment !== '' && this.item.toc.attachment !== null
      }
    },
    props: {
      item: Object,
      type: {
        type: String,
        default: ''
      }
    },
  }
</script>
<style lang="sass" rel="stylesheet/sass">
</style>



// WEBPACK FOOTER //
// DriverToc.vue?22f169a8